const ITEMS = [
  "LEARN. LAUNCH. GROW.",
  "5 BUSINESS MODELS",
  "45-DAY PRACTICAL PROGRAM",
  "OFFLINE CLASSROOM TRAINING",
  "CERTIFICATE INCLUDED",
  "₹14,999 PROGRAM FEE",
  "RAMPUR · UTTAR PRADESH",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="bg-electric py-4 overflow-hidden border-y border-electric-dark" aria-hidden="true">
    <div className="marquee-track mask-fade-x">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center shrink-0">
              <span className="font-display font-bold text-white/95 text-sm sm:text-base tracking-[0.2em] uppercase px-6">{item}</span>
              <span className="w-1.5 h-1.5 rounded-full bg-cyanx shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
